import {ReactNode} from 'react';
import {ChevronLeftRounded} from '@mui/icons-material';
import classes from './ReceiptWizardLayout.module.scss';

interface ReceiptWizardLayoutProps {
  title: string;
  tourStage?: string;
  titleId?: string;
  subtitle?: string;
  onBack?: () => void;
  backLabel?: string;
  backDisabled?: boolean;
  accessory?: ReactNode;
  children: ReactNode;
  contentClassName?: string;
}

export default function ReceiptWizardLayout({title, tourStage, titleId, subtitle, onBack, backLabel = 'Back',
  backDisabled, accessory, children, contentClassName}: ReceiptWizardLayoutProps) {
  return <div className={classes.layout} data-tour-stage={tourStage}>
    <header className={classes.header}>
      <div className={classes.headerInner}>
        {onBack ? <button type="button" aria-label={backLabel} disabled={backDisabled} onClick={onBack}>
          <ChevronLeftRounded/>
        </button> : <span className={classes.brand}><img src="/plan-m-light.png" alt="" aria-hidden="true"/></span>}
        <div className={classes.heading}>
          <h1 id={titleId}>{title}</h1>
          {subtitle && <p>{subtitle}</p>}
        </div>
        {accessory && <div className={classes.accessory}>{accessory}</div>}
      </div>
    </header>
    <div className={`${classes.content} ${contentClassName ?? ''}`}>{children}</div>
  </div>;
}
